import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import defaultAvatarThumb from '../../../images/default_dealer_thumb.png';
import adminAvatarThumb from '../../../images/admin-avatar.png';
import './Message.scss';

const Message = ({ body, isAdmin, createdAt, avatarThumb, }) => {
  const avatarSrc = (isAdmin ? adminAvatarThumb : avatarThumb || defaultAvatarThumb);
  const chatMessageClasses = classNames('chat-message', { admin: isAdmin, });
  const formattedDate = moment(createdAt).format('DD/MM/YYYY HH:mm');
  return (
    <div className={chatMessageClasses}>
      <span className="chat-message__date">{formattedDate}</span>
      <div className="chat-message__body">
        <span className="chat-message__text">
          {body}
        </span>
        <img alt="avatar thumb" src={avatarSrc} />
      </div>
    </div>
  );
};

Message.propTypes = {
  body: PropTypes.string,
  isAdmin: PropTypes.bool,
  createdAt: PropTypes.string,
  avatarThumb: PropTypes.string,
};

Message.defaultProps = {
  body: '',
  isAdmin: null,
  createdAt: null,
  avatarThumb: null,
};

export default Message;
